const countries = [
  { countryCode: "US", value: "1", label: "USA (+1)" },
  { countryCode: "AR", value: "54", label: "Argentina (+54)" },
  { countryCode: "BO", value: "591", label: "Bolivia (+591)" },
  { countryCode: "BR", value: "55", label: "Brazil (+55)" },
  { countryCode: "CL", value: "56", label: "Chile (+56)" },
  { countryCode: "CO", value: "57", label: "Colombia (+57)" },
  { countryCode: "CR", value: "506", label: "Costa Rica (+506)" },
  { countryCode: "EC", value: "593", label: "Ecuador (+593)" },
  { countryCode: "SV", value: "503", label: "El Salvador (+503)" },
  { countryCode: "GT", value: "502", label: "Guatemala (+502)" },
  { countryCode: "HN", value: "504", label: "Honduras (+504)" },
  { countryCode: "MX", value: "52", label: "Mexico (+52)" },
  { countryCode: "PY", value: "595", label: "Paraguay (+595)" },
  { countryCode: "PE", value: "51", label: "Peru (+51)" },
  { countryCode: "PR", value: "1787", label: "Puerto Rico (+1787)" },
  { countryCode: "UY", value: "598", label: "Uruguay (+598)" },
  { countryCode: "VE", value: "58", label: "Venezuela (+58)" }
];

export default countries;
